import React from 'react';
import classnames from 'classnames';
import PerfectScrollbar from 'perfect-scrollbar';
import { element, string, shape, bool } from 'prop-types';

import 'perfect-scrollbar/css/perfect-scrollbar.css';

const handlers = {
  'ps-scroll-y': 'onScrollY',
  'ps-scroll-x': 'onScrollX',
  'ps-scroll-up': 'onScrollUp',
  'ps-scroll-down': 'onScrollDown',
  'ps-scroll-left': 'onScrollLeft',
  'ps-scroll-right': 'onScrollRight',
  'ps-y-reach-start': 'onYReachStart',
  'ps-y-reach-end': 'onYReachEnd',
  'ps-x-reach-start': 'onXReachStart',
  'ps-x-reach-end': 'onXReachEnd',
};
Object.freeze(handlers);

class ScrollContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handlers = new Map();
  }

  componentDidMount() {
    const { settings } = this.props;
    this.ps = new PerfectScrollbar(this.root, { ...settings });

    Object.keys(handlers).forEach((eventKey) => {
      const handler = this.props[handlers[eventKey]];

      if (handler) {
        this.handlers.set(eventKey, handler);
        this.root.addEventListener(eventKey, handler);
      }
    });
  }

  componentDidUpdate() {
    // For many grids amount of elements is not changes dynamically
    if (!this.props.static) {
      this.ps.update();
    }
  }

  componentWillUnmount() {
    Object.keys(this.handlers).forEach((handler, eventKey) => {
      this.root.removeEventListener(eventKey, handler);
    });

    this.handlers.clear();
    this.ps.destroy();
    this.ps = null;
    this.handlers = null;
  }

  render() {
    const { className, children, useRef } = this.props;
    return React.cloneElement(React.Children.only(children), {
      [useRef]: ((cmp) => { this.root = cmp; }),
      className: classnames(
        className,
        'scrollbar-container',
        children.props.className,
      ),
    });
  }
}

ScrollContainer.propTypes = {
  children: element.isRequired,
  useRef: string,
  className: string,
  settings: shape(),
  static: bool,
};

ScrollContainer.defaultProps = {
  className: null,
  static: true,
  useRef: 'ref',
  settings: {},
};

export default ScrollContainer;
